export enum MENU_ITEM {
  WRITING = 'Writing',
  CITATIONS = 'Citations',
  PLAGIARISM = 'Plagiarism',
}
